export class FirstAccessModel {
    senha: string;
    confirmaSenha: string;
}
